import React from 'react'
import { Col, Row } from '@vega/styled'
import { styled, s } from '@vega/styled/v2'
import {
  ContentCard as ContentCardBase,
  SectionTitle as SectionTitleBase,
  DataDisplay,
} from '../components'
import { APPLICATION_INFO_SECTION_IDS } from '../constants'
import { isNotNilOrEmpty } from '@solta/ramda-extra'
import { Loading } from '@vega/components'
import { TEST_IDS } from '@vega/constants'

const { HOUSEHOLD_INFO } = APPLICATION_INFO_SECTION_IDS
const Container = styled.div({ marginBottom: 52 })
const SectionTitle = styled(SectionTitleBase)(s('mb-4'))
const ContentCard = styled(ContentCardBase)(s('mb-4'))
const Heading = styled.div(
  s('mb-2 text-sm text-primary font-semibold', {
    letterSpacing: '0.01em',
    lineHeight: 1.5,
  })
)

const getAllNamesOfApplicantsInHousehold = (applicants, householdId) =>
  applicants
    .filter((applicant) => applicant?.household?.externalRef === householdId)
    .map((applicant) => applicant?.fullName)
    .join(', ')

const HouseholdInfo = ({ applicants, householdInfo, ...props }) => {
  if (!Array.isArray(householdInfo)) return <Loading />

  return (
    <Container id={HOUSEHOLD_INFO} {...props}>
      <SectionTitle title="Household Information" />

      <ContentCard>
        <Row gutter={[16, 16]}>
          {householdInfo?.map((householdDetail, index) => (
            <Col key={index} span={24}>
              <Heading>
                {getAllNamesOfApplicantsInHousehold(
                  applicants,
                  householdDetail?.externalRef
                )}
              </Heading>

              <Row justify="start">
                <Col span={12}>
                  <DataDisplay
                    label="No. of Dependants"
                    testId={`${TEST_IDS.HOUSEHOLD_DEP_NO}`}
                    value={householdDetail?.numberOfDependants}
                  />
                </Col>

                <Col span={12}>
                  <DataDisplay
                    label="No. of Adults"
                    testId={`${TEST_IDS.HOUSEHOLD_ADULT_NO}`}
                    value={householdDetail?.numberOfAdults}
                  />
                </Col>
              </Row>

              {isNotNilOrEmpty(householdDetail?.dependants) &&
                householdDetail?.dependants?.map((dependant, externalRef) => (
                  <div key={externalRef} style={s('mt-2')}>
                    <Row justify="start">
                      <Col span={6}>
                        <DataDisplay label="Name:" value={dependant?.name} />
                      </Col>

                      <Col span={6}>
                        <DataDisplay label="Age:" value={dependant?.age} />
                      </Col>
                    </Row>
                  </div>
                ))}
            </Col>
          ))}
        </Row>
      </ContentCard>
    </Container>
  )
}

export { HouseholdInfo }
